import React from 'react';
import ReferralContainer from '@src/containers/Referral';

const Referral = () => <ReferralContainer />;

export default Referral;
